import React, { useContext } from "react";
import DesignPageContainer from "./containers/DesignPageContainer";
import OrderPageContainer from "./containers/OrderPageContainer";

import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { useState } from "react";



const AppContainer = () => {

  const [sidebarActive, setSidebarActive] = useState(true)
  

  const toggleSidebar = () => {
    let sidebar = document.querySelector(".side-bar");
    document.querySelector(".main-container").classList.add("expanded");

    if (sidebar === null) {
      sidebar = document.querySelector(".side-bar-icons");
      document.querySelector(".main-container").classList.remove("expanded");
    }

    const width = sidebar.offsetWidth;
    sidebar.style.left = -5 * width + "px"; // *-1 is enough, but when switching from collapsed view to expanded view, it doesn't work properly (as it isn't far enough 'left')
  
    setTimeout(() => {
      setSidebarActive(!sidebarActive)
      sidebar.style.left = "0px";
    }, 250);
  }
  return (
    <Router basename='/VanDenHeuvel/KPWC'>
      <Switch>
        <Route exact path='/' render={(props) => <DesignPageContainer {...props} toggleSidebar={toggleSidebar} sidebarActive={sidebarActive} />} />
        <Route path='/order' render={(props) => <OrderPageContainer {...props} toggleSidebar={toggleSidebar} sidebarActive={sidebarActive} />} />
      </Switch>
    </Router>
  );
}

export default AppContainer;
